import type { SpartanVideoStartMode } from '@/app/lcv/components/sections/spartan/products/shared/in-view-video/types';

export const SPARTAN_IN_VIEW_VIDEO_DEFAULT_SIZES =
  '(min-width: 1280px) 560px, (min-width: 768px) 50vw, 100vw';

export const SPARTAN_IN_VIEW_VIDEO_IN_VIEW_OPTIONS = {
  rootMargin: '0px',
  threshold: 0.7,
  triggerOnce: false,
} as const;

export const SPARTAN_IN_VIEW_VIDEO_TRACKING_PREFIX = 'spartan-in-view-video';

export const getSpartanVideoVisibilityThreshold = (
  startMode: SpartanVideoStartMode
): number => {
  if (startMode === 'near-full') return 0.85;
  if (startMode === 'visible') return 0.6;
  return 0;
};
